import { cn } from "@coideo/barrani";
import { XCircleIcon } from "@heroicons/react/solid";
import { useTranslation } from "next-i18next";
import parseError, { type CustomError } from "utils/parse-error";

function AlertError({
  className,
  children,
}: {
  className?: string;
  children?: CustomError | null;
}) {
  const { t } = useTranslation();
  const key = children ? parseError(children) : "";

  return children ? (
    <div className={cn(className, "rounded-md bg-red-50 p-4")} role="alert">
      <div className="flex">
        <div className="shrink-0">
          <XCircleIcon aria-hidden="true" className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium leading-5 text-red-800">
            {t(`errors.api.${key}`, key, { ...(children.errors ?? {}) })}
          </p>
        </div>
      </div>
    </div>
  ) : null;
}

export default AlertError;
